<template>
  <div
    id="app"
    :class="{'menu-collapsed': menuCollapsed, 'menu-hidden': menuHidden}"
  >
    <div
      v-if="!isFourthVersion"
      class="navbar-wrap"
    >
      <Navbar />
    </div>
    <info
      v-if="showAccessDeniedInfo"
      title="Access Denied"
      text="You don't have permission to access requested page."
    />
    <fragment v-else-if="adpPermissionDataReady">
      <Sidebar />
      <div
        id="content"
        class="content"
        :style=" isFourthVersion ? { paddingLeft: menuPin ? '440px' : '60px', transition: '0.4s' } : {} "
      >
        <router-view :key="$route.fullPath" />
      </div>
    </fragment>
    <confirm-modal />
  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import Sidebar from '../../sidebar/Sidebar';
import Navbar from '../../navbar/Navbar';
import auth from '../../../services/auth.service';
import ConfirmModal from '../../../../plugins/confirm-modal/ConfirmModal';
import Info from '../../pages/Info';

const {mapState} = createNamespacedHelpers('app');
const {mapActions: mapActionsUser, mapState: mapStateUser} = createNamespacedHelpers('user');
const { mapState: mapStateDataManagement } = createNamespacedHelpers('dataManagement');

export default {
  name: 'DefaultLayout',
  components: {
    Info,
    ConfirmModal,
    Navbar,
    Sidebar,
  },
  data() {
    return {
      modulesData: [],
      menuItemData: [],
      alreadySetItems: {
        module: false,
        folder: false,
        table: false,
      },
      newNavPadding:'60px',
    };
  },
  computed: {
    ...mapState(['allDataLoaded', 'menuCollapsed', 'menuHidden', 'menuPin', 'isFourthVersion']),
    ...mapStateDataManagement(['permissionTypes', 'modules', 'allFolders', 'tables']),
    ...mapStateUser({
      currentUserAdpPermission: state => state.currentUserAdpPermission,
    }),
    adpPermissionDataReady() {
      return this.currentUserAdpPermission.loaded;
    },
    showAccessDeniedInfo() {
      return !this.currentUserAdpPermission.data.role && this.adpPermissionDataReady;
    },
  },
  methods: {
    ...mapActionsUser(['setCurrentUser', 'getCurrentUserAdpPermission']),
    async redirectHomePage() {
      if (['/home', '/'].includes(this.$route.path)) {
        await this.$router.push({name: 'dataManagement'});
      }
    },
    async setUserData() {
      const user = auth.msalApplication.getAccount();
      if (user) {
        try {
          user.avatar = await auth.getUserAvatar();
        } catch (e) {
          // logger.error(e);
        }
        await this.setCurrentUser(user);
      }
    },
  },
  async mounted() {
    await this.getCurrentUserAdpPermission();
    await this.setUserData();
    await this.redirectHomePage();
  },
};
</script>

<style lang="scss" scoped>
  @import "../../../scss/variables";

  #app {
    height: 100%;
    display: grid;
    grid-template-columns: auto 1fr;
    grid-template-rows: auto 1fr;
    overflow: hidden;
    grid-template-areas:
    "navbar navbar"
    "sidebar content";
  }

  .navbar-wrap {
    grid-area: navbar;
  }

  .sidebar-wrap {
    position: relative;
    width: 0;
    grid-area: sidebar;
    transition: 0.4s;

    &.show {
      width: 250px;
    }
  }

  .content {
    grid-area: content;
    background-color: #f1f1f1;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    & /deep/ .page {
      overflow: hidden;
      display: flex;
      flex-direction: column;
    }

    & /deep/ .page-content {
      overflow: auto;
    }
  }

  #menu-content-wrapper {
    flex: 1;
    display: flex;
    overflow: hidden;
  }

  #content {
    flex: 1;
    background-color: #f1f1f1;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    & /deep/ .page {
      overflow: hidden;
      display: flex;
      flex-direction: column;
    }

    & /deep/ .page-content {
      overflow: auto;
    }
  }
</style>
